import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Modal} from 'letrus-ui';
import {MissingQuestion} from 'APIs/letrusAPI/questionnaire/types';
import styles from './MissingQuestionsModal.module.scss';

export interface MissingQuestionsModalProps {
  id: string;
  missingQuestions: MissingQuestion[];
  onGoBack(): void;
}

function MissingQuestionsModal({
  id,
  missingQuestions,
  onGoBack,
}: MissingQuestionsModalProps) {
  const questionNumbers = missingQuestions?.map((question) => question.order);
  const formattedNumbers = questionNumbers.join(', ');

  return (
    <Modal closeButton id={id}>
      <div className={styles.wrapper} data-testid="missing-questions-modal">
        <FontAwesomeIcon size="3x" icon="circle-exclamation" color="#C4444D" />

        <div className={styles.content}>
          <h3>Atenção</h3>

          <p>
            Você ainda tem{' '}
            <strong>
              {questionNumbers.length}{' '}
              {questionNumbers.length === 1 ? 'questão' : 'questões'}
            </strong>{' '}
            sem resposta. Para avançar para a próxima etapa, todas as perguntas
            precisam estar respondidas.
          </p>

          <strong>
            {questionNumbers.length === 1
              ? `Passo pendente desse questionário: ${formattedNumbers}`
              : `Passos pendentes desse questionário: ${formattedNumbers}`}
          </strong>

          {questionNumbers.length === 1 ? (
            <p>
              Ao clicar no botão abaixo, você será redirecionado para a questão
              sem resposta.
            </p>
          ) : (
            <p>
              Ao clicar no botão abaixo, você será redirecionado para a primeira
              questão sem resposta. Lembre-se de verificar as demais também.
            </p>
          )}
        </div>

        <Button onClick={onGoBack} variant="primary">
          Voltar para o questionário
        </Button>
      </div>
    </Modal>
  );
}

export default MissingQuestionsModal;
